import { inject, Injectable } from '@angular/core';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OwnerTransferEvent, OwnerTransferIndexItem } from '@web/csl-lib-models';

@Injectable({
  providedIn: 'root'
})
export class ClinicOwnerTransferService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getClinicIndex(clinicId: number) : Observable<OwnerTransferIndexItem[]> {
    return this.http.get<OwnerTransferIndexItem[]>(`${this.apiUrl}/clinics/${clinicId}/ownerTransfers/index`);
  }

  getEvents(clinicId: number, ownerTransferId: number): Observable<OwnerTransferEvent[]> {
    return this.http.get<OwnerTransferEvent[]>(`${this.apiUrl}/clinics/${clinicId}/ownerTransfers/${ownerTransferId}/events`);
  }

  getPendingCount(clinicId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/clinics/${clinicId}/ownerTransfers/pendingCount`);
  }
}
